import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TransitionMotion, spring, presets } from 'react-motion'
import styles from './wizard.styl'

export default class Wizard extends Component {
  static propTypes = {
    links: PropTypes.any,
    route: PropTypes.object
  }
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {}
  }

  willEnter = () => {
    return { size: 0.6, opacity: 0 }
  }

  willLeave = () => {
    return { size: spring(0, presets.stiff), opacity: spring(0, presets.stiff) }
  }

  render() {
    const { links } = this.props

    const activeArr = links
      .filter(item => {
        return item.active === true
      })
      .map(item => ({
        key: `${item.id}`,
        data: item,
        style: {
          size: spring(1, presets.stiff),
          opacity: spring(1, presets.stiff)
        }
      }))

    return (
      <div>
        <TransitionMotion
          willEnter={this.willEnter}
          willLeave={this.willLeave}
          styles={activeArr.toArray()}
        >
          {interpolatedStyles => (
            <ul className={styles.wizard}>
              {interpolatedStyles.map(obj => {
                const active = this.props.route.activeId === obj.data.id
                  ? styles.active
                  : ''

                return (
                  <li
                    key={obj.key}
                    style={{
                      transform: `scale3d(${obj.style.size}, ${obj.style.size}, ${obj.style.size})`,
                      opacity: obj.style.opacity
                    }}
                    className={styles.item + ' ' + active}
                  >
                    {obj.data.label}
                  </li>
                )
              })}
            </ul>
          )}
        </TransitionMotion>
      </div>
    )
  }
}
